import { Navigate, useLocation } from 'react-router-dom';
import { legacyOrgAdminRedirectTarget } from '@/config/settingsLegacyRedirects';
import { SETTINGS_PATH, getSettingsRouteForLegacyPath } from '@/config/settingsRegistry';
import { useActiveModule } from '@/hooks/useActiveModule';
import { useAppSelector } from '@/hooks/useAppSelector';
import type { ErpModule } from '@/api/platform.api';

export function LegacyOrgAdminRedirect({ fallbackModule = 'POS' }: { fallbackModule?: ErpModule }) {
  const location = useLocation();
  const activeModule = useActiveModule();
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const module = activeModule ?? entryModule ?? fallbackModule;
  const target =
    legacyOrgAdminRedirectTarget(location.pathname, module) ??
    getSettingsRouteForLegacyPath(location.pathname, location.search) ??
    SETTINGS_PATH;
  return <Navigate to={target} replace />;
}
